var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pic-url"},_vm._l((_vm.picUrlList),function(item){return _c('img',{key:item.url,class:{ fullImg: item.isFull },attrs:{"src":item.url},on:{"click":function($event){return _vm.onFullImageUrl(item)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }